import HeaderDesktop from './HeaderDesktop';
import CheckoutHomeDesktopLayout from '../layouts/CheckoutHomeDesktopLayout';
import { Grid, Box, Container } from '@mui/material';
import EventInfo from './EventNav/EventInfo';
import EventSummary from './EventNav/EventSummary';
import FanPass from './FanPass';

export default function FanPassDesktop({ onChange, fanPass }) {
  return (
    <>
      <HeaderDesktop />
      <CheckoutHomeDesktopLayout>
        <Grid container spacing={2} sx={{ height: '100%', marginTop: '0px' }}>
          <Grid
            item
            md={6}
            sx={{
              height: '100%',
              backgroundColor: (theme) => theme.palette.background.default,
              boxShadow: (theme) => theme.customShadows.side,
              pt: 0,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'scroll',
              }}
            >
              <Box
                sx={{
                  mr: '24px',
                  ml: '24px',
                  mb: 4,
                }}
              >
                <EventSummary />
              </Box>
              <Box
                sx={{
                  mr: '24px',
                  ml: '24px',
                  mb: 2,
                }}
              >
                <FanPass onChange={onChange} fanPass={fanPass}/>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            md={6}
            sx={{
              width: '100%',
              height: '100%',
              overflow: 'scroll',
            }}
          >
            <Container>
              <EventInfo hideCloseBtn />
            </Container>
          </Grid>
        </Grid>
      </CheckoutHomeDesktopLayout>
    </>
  );
}
